import en from './en';
import mn from './mn';

export default { en, mn };



// WEBPACK FOOTER //
// ./src/locales/index.js